<template>
  <div id="app">
    <!-- RENDER THE APPLICATION HEADER -->
    <HeaderView/>

    <!-- RENDER THE ROUTED COMPONENTS -->   
    <router-view/>
    
    <!-- RENDER THE APPLICATION FOOTER -->
    <FooterView/>

    <!-- MODAL DIALOG SUPPORT -->
    <!--<modals-container />-->
  </div>
</template>

<script>

//import HeaderView from './components/header/header.vue' ;
const HeaderView = require( './components/header/header.vue?v=' + process.env.VUE_APP_VERSION ).default;
//import FooterView from './components/footer/footer.vue';
const FooterView = require( './components/footer/footer.vue?v=' + process.env.VUE_APP_VERSION ).default;

export default {
  name: 'app',
  components: {
    HeaderView,
    FooterView
  },
  computed: {
  }
}
</script>
<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
